export default {
	list: 'VestingSchedule',
	grid: {
		pageable: false,
		editable: true
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly:false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'ProgramId',
			width: 100,
			hidden: true,
			readOnly:false
		},
		ProgramID: {
			class: 'lookup',
			dataName: 'Program/ProgramID',
			type: 'string',
			title: 'ProgramID',
			width: 100,
			hidden: true,
			readOnly: true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			dropdown:true,
			title: 'Unit Class',
			width: 125,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			dropdown:true,
			title: 'Unit Type',
			width: 150,
			hidden: false,
			readOnly:false
		},
		VestingType: {
			class: 'choice',
			dataName: 'VestingType',
			type: 'string',
			dropdown:true,
			title: 'Vesting Type',
			width: 150,
			hidden: false,
			readOnly:false
		},
		Year: {
			class: 'value',
			dataName: 'Year',
			type: 'number',
			title: 'Year',
			dropdown:true,
			//format: '#= Year == null ? "NA": Year #',
			validation: { min: 0, max:4},
			width: 75,
			hidden: false,
			readOnly:false
		},
		VestDate: {
			class: 'value',
			dataName: 'VestDate',
			type: 'date',
			title: 'Vesting Date',
			width: 150,
			hidden: false,
			readOnly:false
		},
		Percentage: {
			class: 'value',
			dataName: 'Percentage',
			type: 'number',
			title: 'Percentage',
			editorType: 'percentEditor',
			template : '#= kendo.toString(Percentage*100, "n2") #' + ' %',
			//format : "{0:p}",
			//validation: { min: 0.00, max:1, step: 0.01},
			width: 125,
			hidden: false,
			readOnly:false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'multiline',
			title: 'Note',
			width: 400,
			hidden: false
		},
		AfterIssuance:{
			class: 'value',
			dataName: 'AfterIssuance',
			type: 'string',
			title: 'After Issuance',
			width: 150,
			hidden: true
		}
	}
}